<template>
  <div>
    <section v-if="!finished">
      <h3
        class="kitxva"
        v-html="`<span>${(current_question + 1)}.</span>${questions[current_question].question}`"
      ></h3>
      <form class="option-wrapper pb-3" @submit.prevent="nextQuestion">
        <div
          class="custom-control custom-radio option d-flex"
          v-for="(q, index) in questions[current_question].options"
          :key="q.id"
        >
          <input
            v-model="answer"
            :id="'customRadio' + index"
            required="required"
            type="radio"
            name="customRadio"
            class="custom-control-input"
            :value="q"
          />
          <label class="custom-control-label" :for="'customRadio' + index" v-html="q.option"></label>
        </div>
        <div class="text-right text-sm-center pr-10">
          <button type="submit" class="btn btn-primary mb-2">შემდეგი</button>
        </div>
      </form>
    </section>
    <section v-else>
      <p>
        ქულა: {{this.getScore()}}
        <br />
        <!-- {{user.name}}  -->
        {{this.getText()}}
      </p>
    </section>
  </div>
</template>

<script>
export default {
  props: ["init_questions"],
  data() {
    return {
      questions: this.init_questions,
      score: 0,
      user: window.App.user,
      current_question: 0,
      answer: null,
      user_answers: [],
      finished: false
    };
  },
  methods: {
    nextQuestion() {
      this.user_answers.push(this.answer);
      this.answer = null;
      this.current_question++;
      if (this.current_question == this.questions.length) {
        this.finished = true;
      }
    },
    getScore() {
      this.score = this.user_answers.reduce((sum, item) => {
        sum + item.score;
      });
      return this.score;
    },
    getText() {
      if (this.score < 4) {
        return "ჩენ ჩაიჭრები :(";
      } else if (this.score < 7) {
        return "შენ კიდევ გაქ შანის";
      } else if (this.score < 100) {
        return "არ მოდუნდე და შენ ნამდივალდ აიღებ გრანტს!";
      } else {
        return "შენ შეძელი წარმოუდგენელი";
      }
    }
  },
  mounted() {
    // this.fetchNotes();
  }
};
</script>

<style lang="scss" scoped>
</style>